export const ADD = 'app/EditSessionPage/HenryFordQuestion/ADD';
export const UPDATE_ANSWER = 'app/EditSessionPage/HenryFordQuestion/UPDATE';
export const UPDATE_VARIABLE =
  'app/EditSessionPage/HenryFordQuestion/UPDATE_VARIABLE';
export const REMOVE = 'app/EditSessionPage/HenryFordQuestion/REMOVE';
export const REORDER = 'app/EditSessionPage/HenryFordQuestion/REORDER';
